import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { faqs } from '@/mocks/faqs';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              kicker="常见问题"
              title="关于时间线的疑问"
              description="如果你对内容的整理方式还有疑问，可以先看看这几个问题，也可以直接联系我们。"
            />
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 border-y border-background-200">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.question}>
                    <h3>
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        className="flex w-full items-center justify-between gap-4 py-5 text-left"
                      >
                        <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                          {item.question}
                        </span>
                        <span
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                            isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                          }`}
                        >
                          <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg`} />
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="pb-5 pr-10">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}